import {
  DISPATCH_DESK_SPLIT_TOP_ROW_CHILD_CLASS,
  DISPATCH_DESK_SPLIT_TOP_ROW_CLASS,
} from "../lib/dispatch-desk-layout";

import {DispatchOnGuardOfficers} from "./dispatch-on-guard-officers";
import {DispatchPropertyManagers} from "./dispatch-property-managers";

/** Col 2 row 1 — Managers + Supervisor 50/50. Grid only — never pass flex layout classes via className. */
export function DispatchPropertyStaffRow() {
  return (
    <div className={DISPATCH_DESK_SPLIT_TOP_ROW_CLASS}>
      <DispatchPropertyManagers className={DISPATCH_DESK_SPLIT_TOP_ROW_CHILD_CLASS} />
      <DispatchOnGuardOfficers className={DISPATCH_DESK_SPLIT_TOP_ROW_CHILD_CLASS} />
    </div>
  );
}
